import { Popover } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { AppScope } from '@/types'

const labelStyle = {
  fontSize: 13,
  lineHeight: '20px',
  color: 'rgba(0, 0, 0, 0.4)',
} as const

function Block({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={labelStyle}>{label}</div>
      {children}
    </div>
  )
}

export default function ScopeDetailPopover({
  scope,
  children,
}: {
  scope: AppScope
  children: ReactNode
}) {
  const { t } = useTranslation()
  const token =
    scope.identity_type === 'app' ? t('scope.token_app') : t('scope.token_user')

  const content = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        padding: 20,
        maxWidth: 320,
        background: '#fff',
        border: '1px solid #DCDCDC',
        borderRadius: 14,
      }}
    >
      <div>
        <div style={{ fontSize: 14, lineHeight: '22px', color: '#000' }}>{scope.name}</div>
        <div style={{ fontSize: 13, lineHeight: '20px', color: 'rgba(0, 0, 0, 0.4)' }}>
          {scope.scope_id}
        </div>
      </div>
      <Block label={t('scope.hoverAccessToken')}>
        <div style={{ fontSize: 12, lineHeight: '18px', color: '#000' }}>
          {t(`scope.identityTab_${scope.identity_type}`)} ({token})
        </div>
      </Block>
      {scope.description ? (
        <Block label={t('scope.hoverDescription')}>
          <div style={{ fontSize: 14, lineHeight: '22px', color: '#000' }}>
            {scope.description}
          </div>
        </Block>
      ) : null}
    </div>
  )

  return (
    <Popover
      trigger="hover"
      placement="topLeft"
      arrow={false}
      content={content}
      styles={{
        container: { padding: 0, background: 'transparent', boxShadow: 'none' },
        content: { padding: 0 },
      }}
    >
      {children}
    </Popover>
  )
}
